import { createSlice, PayloadAction, Slice } from "@reduxjs/toolkit";
import { RootState } from "utils/store";

export interface Primary {
  id: string;
  email: string;
  name: string;
  officePhone: string;
  lastLogin: any;
}

export interface AuthState {
  authenticated: boolean;
  accessToken: string;
  refreshToken: string;
  userName: string;
  email: string;
  isAdmin: boolean;
  id: string;
  firstName: string;
  lastName: string;
}

const initialState: AuthState = {
  authenticated: false,
  accessToken: "",
  refreshToken: "",
  userName: "",
  email: "",
  isAdmin: false,
  id: "",
  firstName: "",
  lastName: "",
};

export const authSlice: Slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginAction: (
      state,
      action: PayloadAction<{
        authenticated: boolean;
        accessToken: string;
        refreshToken: string;
        userName: string;
        email: string;
        isAdmin: boolean;
        id: string;
        firstName: string;
        lastName: string;
      }>,
    ) => {
      state.authenticated = action.payload.authenticated;
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.userName = action.payload.userName;
      state.email = action.payload.email;
      state.isAdmin = action.payload.isAdmin;
      state.id = action.payload.id;
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
    },
    addLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    logOutAction: (state) => {
      state.authenticated = false;
      state.loading = false;
      state.accessToken = "";
      state.refreshToken = "";
      state.isAdmin = false;
      state.id = "";
      state.firstName = "";
      state.lastName = "";
      state.userName = "";
    },
    updateAccessToken: (
      state,
      action: PayloadAction<{ accessToken: string; refreshToken: string }>,
    ) => {
      state.accessToken = action.payload.accessToken;
    },
    // primaryUserAction: (
    //   state,
    //   action: PayloadAction<{
    //     id: string;
    //     email: string;
    //     name: string;
    //     officePhone: string;
    //     lastLogin: any;
    //   }>
    // ) => {
    //   state.primary.id = action.payload.id;
    //   state.primary.email = action.payload.email;
    //   state.primary.name = action.payload.name;
    //   state.primary.officePhone = action.payload.officePhone;
    //   state.primary.lastLogin = action.payload.lastLogin;
    // },
    makeAppDrawerHide: (state, action: PayloadAction<boolean>) => {
      state.hideAppDrawer = action.payload;
    },
    updateUserName: (state, action: PayloadAction<string>) => {
      state.userName = action.payload;
    },
    updateEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
  },
});

export const {
  loginAction,
  logOutAction,
  addLoading,
  makeAppDrawerHide,
  updateUserName,
  updateEmail,
  updateAccessToken,
} = authSlice.actions;

export const selectAuthenticated = (state: RootState) =>
  state.auth.authenticated;
export const selectAccessToken = (state: RootState) => state.auth.accessToken;
export const selectIsAdmin = (state: RootState) => state.auth.isAdmin;
export const selectId = (state: RootState) => state.auth.id;
export const selectFirstName = (state: RootState) => state.auth.firstName;
export const selectLastName = (state: RootState) => state.auth.lastName;
export const selectUserName = (state: RootState) => state.auth.userName;
export const selectEmail = (state: RootState) => state.auth.email;

export default authSlice.reducer;
